(function () {
    'use strict';

    angular
        .module('travelExpenses')
        .controller('ClientCreditsDeleteModalController', ClientCreditsDeleteModalController);

        ClientCreditsDeleteModalController.$inject = ['$uibModalInstance', 'ClientService', 'clientCredits', 'credit', 'toastr'];

    function ClientCreditsDeleteModalController($uibModalInstance, ClientService, clientCredits, credit, toastr) {
        var vm = this;

        vm.credit       = credit;
        vm.formatDate   = formatDate;
        vm.ok           = ok;
        vm.cancel       = cancel;

        function formatDate(date) {
            return moment(date).format('DD/MM/YYYY');
        }

        activate();

        function activate() {
        }

        function ok () {
            ClientService.deleteClientCredit(vm.credit.id).then(function(response, status) {
                if(response.status !== 200) {
                    toastr.error("An error ocurred on delete this credit");
                } else {
                    toastr.success("Client credit successfully deleted!");
                    clientCredits.getByFilter();
                    $uibModalInstance.close();
                }
            }).catch(function(err) {
                toastr.error('Error:'+err);
            });
        }

        function cancel () {
            $uibModalInstance.close();
        }
    }
})();